module.exports = "/_next/static/images/business-operations-header-7f5da65be5eabccadc1af519b14b4485.webp";